import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css';
import {Tabbar, TabbarItem} from 'vant';
import {Empty} from 'vant';
import {Col, Row} from 'vant';
import {Image as VanImage} from 'vant';
import {Cell, CellGroup} from 'vant';
import axios from 'axios'
import {Loading} from 'vant';
import {Overlay} from 'vant';
import { Dialog } from 'vant';
import { ActionSheet } from 'vant';
import { Field } from 'vant';
import { Button } from 'vant';
import { Notify } from 'vant';
import { Toast } from 'vant';
import { List } from 'vant';
import { PullRefresh } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Popup } from 'vant';
import { Icon } from 'vant';
import { Grid, GridItem } from 'vant';
import { Tab, Tabs } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Progress } from 'vant';
import { Area } from 'vant';
import {Checkbox} from "vant";

Vue.use(Checkbox);
Vue.use(Area);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Toast);
Vue.use(Notify);
Vue.use(Button);
Vue.use(Field);
Vue.use(ActionSheet);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Empty);
Vue.use(Col);
Vue.use(Row);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(VanImage);
Vue.use(Dialog);

Vue.config.productionTip = false
// 配置请求的根路径
axios.defaults.baseURL = 'https://app.huluyanxuan.com/api/ydt'
//axios.defaults.baseURL = 'http://127.0.0.1:8180/ydt'

// 配置请求拦截器
axios.interceptors.request.use(
    // 请求之前做的
    config => {
        config['headers']['common']['Accept'] = 'application/json';
        /*let token = localStorage.getItem("loginToken");
        if (token) { // 每次发送请求之前判断是否存在token，
            //如果存在，则统一在http请求的header都加上token，
            //不用每次请求都手动添加了
            config.headers.Authentication = token;
        }*/
        return config;
    },
    // 请求错误做的
    err => {
        return Promise.reject(err);
    });

// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
axios.interceptors.response.use(
    // 对正常响应数据做的
    response => {
        let data = response.data;
        let code = data.code;
        if(code == 403){
            // 认证不通过
          /*  Dialog.alert({
                message: '登录信息过期，即将重新登录',
            }).then(() => {
                // on close
                window.location.replace(axios.defaults.baseURL + '/wx/index');
            });*/
        }else if(code != 0){
            if(code == -1 || code == 500 || code == 401){
                console.log("服务端响应不成功");
                console.log(response);
                let msg = data.message;
                if(msg == undefined || msg == null || msg == ''){
                    msg = data.msg;
                }
                Dialog.alert({
                    message: msg,
                })
            }
        }
        return response;
    },

    // 对响应错误的数据做的，如果响应码不是200,就会被拦截到这儿
error => {
        if (error.response) {
            this.$dialog.alert({
                message: '请求失败',
            })
        }
    });

// 将axios 设置成Vue的原型属性，方便引用
Vue.prototype.$http = axios

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
